<template>
    <form class="form-horizontal" v-if="config">

        <div class="form-group">
            <label for="ignicao" class="col-sm-2 control-label">HABILITAR:</label>
            <div class="col-sm-3">
                <select v-model="config.dpa_enable" class="form-control" id="ignicao">
                    <option :value="false">Não</option>
                    <option :value="true">Sim</option>
                </select>
            </div>
            <label for="dpa_base_speed" class="col-sm-2 control-label">VELOCIDADE MÍNIMA:</label>
            <div class="col-sm-1">
                <input type="number" v-model.number="config.dpa_base_speed" class="form-control input-sm" id="dpa_base_speed">
            </div>
        </div>

        <div class="form-group">
            <label for="dpa_fast_acceleration" class="col-sm-2 control-label">ACELERAÇÃO BRUSCA</label>
            <div class="col-sm-2">
                <input type="number" v-model.number="config.dpa_fast_acceleration" class="form-control input-sm" id="dpa_fast_acceleration">
            </div>

        </div>
        <div class="form-group">

            <label for="dpa_harsh_brake" class="col-sm-2 control-label">FREADA BRUSCA</label>
            <div class="col-sm-2">
                <input type="number" v-model.number="config.dpa_harsh_brake" class="form-control input-sm" id="dpa_harsh_brake">
            </div>

        </div>
        <div class="form-group">

            <label for="dpa_sharp_turn" class="col-sm-2 control-label">CURVA ACENTUADA</label>
            <div class="col-sm-2">
                <input type="number" v-model.number="config.dpa_sharp_turn" class="form-control input-sm" id="dpa_sharp_turn">
            </div>
        </div>

        <div class="form-group">
            <label for="dpa_enable_buzzer" class="col-sm-2 control-label">HABILITAR SIRENE:</label>
            <div class="col-sm-3">
                <select v-model="config.dpa_enable_buzzer" class="form-control" id="dpa_enable_buzzer">
                    <option :value="false">NÃO</option>
                    <option :value="true">SIM</option>
                </select>
            </div>
            <label for="dpa_time_buzzer" class="col-sm-2 control-label">TEMPO PARA ATIVAR (Seg):</label>
            <div class="col-sm-1">
                <input type="number" v-model.number="config.dpa_time_buzzer" class="form-control input-sm" id="dpa_time_buzzer">
            </div>
        </div>


        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
                <button @click="send()" type="button" class="btn btn-success">
                    <i class="fa fa-save"></i> ENVIAR CONFIGURAÇÃO
                </button>
            </div>
        </div>

    </form>
</template>

<script>
    import {Suntech} from "../../../../class";
    import {Bus} from '../../../../class/bus';
    export default {
        name: "PadraoDirecao",
        props: {
            config: {
                default: null
            }
        },
        methods: {
            send () {
                swal({
                    title: 'Posso Confirmar?',
                    text: "Deseja realmente enviar esta configuração?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, pode enviar!'
                }).then(async () => {
                    try {
                        await Suntech.sendPadraoDirecao(this.config);
                        Bus.$emit('comandos');
                        toastr.success("Configuração enviada!");
                    } catch (err) {
                        console.error(err);
                        return toastr.error("Configuração não enviada!");
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>
